import { createSlice } from '@reduxjs/toolkit';
import { TRegion } from 'shared/common/types/regions';

const initialState: TRegion[] = [];

/* istanbul ignore next */
const regionsSlice = createSlice({
  initialState,
  name: 'regions',
  reducers: {},
});

export const { reducer: regionsReducer } = regionsSlice;
